import { INITIAL_STATE_PAGINATION } from '../../../../constants';
import { ADD_SHIPPING_REPORTS, UPDATE_SHIPPING_REPORT } from './actions';

const shippingReportsReducer = (state = INITIAL_STATE_PAGINATION, action) => {
     switch (action.type) {
          case ADD_SHIPPING_REPORTS: {
               return action.payload;
          }
          case UPDATE_SHIPPING_REPORT: {
               const payload = action.payload;
               const { id, ...valueUpdate } = payload;
               const shippingReports = [...state.rows];
               const shippingRowIndex = shippingReports.findIndex((shipping) => shipping.id === payload.id);

               if (shippingRowIndex !== -1) {
                    shippingReports[shippingRowIndex] = {
                         ...shippingReports[shippingRowIndex],
                         ...valueUpdate,
                    };
                    return {
                         ...state,
                         rows: shippingReports,
                    };
               }

               return { ...state };
          }
          default:
               return state;
     }
};

export default shippingReportsReducer;
